import React from 'react'

const clientesRoutes = [
    {
        path: '/clientes',
        exact: true,
        component: React.lazy(() => import('./cadastros/lista/ClientesListIndex')),
    },
    {
        path: '/clientes/visualizar/:clienteId',
        exact: true,
        component: React.lazy(() => import('./visualizar/ClienteViewIndex')),
    },
    {
        path: '/clientes/novo',
        exact: true,
        component: React.lazy(() => import('./cadastros/form/Form')),
    },
    {
        path: '/clientes/validacao-resgates',
        exact: true,
        component: React.lazy(() => import('./validacaoResgates/lista/Table')),
    },
    {
        path: '/clientes/extratos/geral',
        exact: true,
        component: React.lazy(() => import('./extratos/geral/lista/MyTable')),
    },
    {
        path: '/clientes/extratos/individual/',
        exact: true,
        component: React.lazy(() => import('./extratos/individual/lista/MyTable')),
    }, 
]

export default clientesRoutes
